const PersonCircledIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 3.25C8.63737 3.25018 5.57232 5.17733 4.11495 8.20774C2.65759 11.2382 3.06576 14.8356 5.165 17.4625C6.0525 16.0325 8.00625 14.5 12 14.5C15.9937 14.5 17.9462 16.0312 18.835 17.4625C20.9342 14.8356 21.3424 11.2382 19.885 8.20774C18.4277 5.17733 15.3626 3.25018 12 3.25ZM12 13.25C14.0711 13.25 15.75 11.5711 15.75 9.5C15.75 7.42893 14.0711 5.75 12 5.75C9.92893 5.75 8.25 7.42893 8.25 9.5C8.25 11.5711 9.92893 13.25 12 13.25Z"
      fill="currentColor"
    />
  </svg>
);

export default PersonCircledIcon;
